import {LovValueSummary} from '../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {SummaryModel} from '../../../../../common/entity/summary.model';
import {PersonSummaryModel} from '../../../../../person/api/entity/personSummary.model';
import {PermissionsModel} from '../../../../../common/entity/permissions.model';

export class PartnerPersonSummaryModel implements SummaryModel {
    id: number;
    person: PersonSummaryModel;
    type: LovValueSummary;
    permissions: PermissionsModel;
}
